"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _TableCell = _interopRequireDefault(require("../TableCell"));

var _TableRow = require("./TableRow.styles");

var _idGenerator = _interopRequireDefault(require("../../../../utils/idGenerator"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var TableRow = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(TableRow, _React$PureComponent);

  var _super = _createSuper(TableRow);

  function TableRow() {
    var _this;

    _classCallCheck(this, TableRow);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "calculateBases", function () {
      var rowContent = _this.props.content.rowContent;
      var basisArray = rowContent.map(function (content) {
        return content.basis || 0;
      });
      var baselessCells = basisArray.filter(function (basis) {
        return !basis;
      }).length;
      var remainingBasis = 100 - basisArray.reduce(function (sum, basis) {
        return sum + basis;
      });
      return basisArray.map(function (basis) {
        return basis || 1 / baselessCells * remainingBasis;
      });
    });

    _defineProperty(_assertThisInitialized(_this), "buildTableCells", function () {
      var _this$props = _this.props,
          titleBar = _this$props.titleBar,
          _this$props$content = _this$props.content,
          rowContent = _this$props$content.rowContent,
          isBold = _this$props$content.isBold,
          errors = _this$props$content.errors;

      var calculatedBases = _this.calculateBases();

      var hasErrors = !!(errors && errors.length);
      return rowContent.map(function (content, i) {
        return /*#__PURE__*/_react.default.createElement(_TableCell.default, {
          key: (0, _idGenerator.default)(),
          isBold: isBold || content.isBold,
          cellContent: content,
          titleBar: titleBar,
          hasErrors: hasErrors,
          basis: calculatedBases[i]
        });
      });
    });

    return _this;
  }

  _createClass(TableRow, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          className = _this$props2.className,
          currentError = _this$props2.currentError,
          prevError = _this$props2.prevError;
      return /*#__PURE__*/_react.default.createElement(_TableRow.StyledTableRow, {
        className: className,
        currentError: currentError,
        prevError: prevError,
        "data-test-id": "table-row"
      }, this.buildTableCells());
    }
  }]);

  return TableRow;
}(_react.default.PureComponent);

_defineProperty(TableRow, "propTypes", {
  /** Class Override */
  className: _propTypes.default.string,

  /** Content for cells */
  content: _propTypes.default.shape({
    rowContent: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object, _propTypes.default.node])),
    isBold: _propTypes.default.bool,
    errors: _propTypes.default.arrayOf(_propTypes.default.string)
  }).isRequired,

  /** Error flags for styling */
  currentError: _propTypes.default.bool.isRequired,
  prevError: _propTypes.default.bool.isRequired,

  /** Set titlebar styling */
  titleBar: _propTypes.default.bool
});

_defineProperty(TableRow, "defaultProps", {
  className: '',
  titleBar: false
});

var _default = TableRow;
exports.default = _default;